(ns app.front.view.phase-event.section
  (:require [app.front.view.phase-event.list :as phase-event-list]
            [app.front.view.workspace.section :as ws-section]))

(defn section
  [{:keys [phase state]}]
  (let [target-id (:db/id phase)]
    [ws-section/section
     phase
     :phase-event-section
     state
     :view/phase-event
     true
     ^{:key "phase-event"}
     [phase-event-list/view target-id]]))
